/**
 * 개발버전 배지 — 개발 서버에서만 우하단에 '개발버전'(반투명 빨강) 표시.
 *
 * 판정 기준(사용자 확정): **호스트명**으로만 판단한다(http/https 프로토콜 무관).
 *   - 라이브(production): https://zl-tools.nxithub.com  → 배지 숨김
 *   - 개발(dev):          https://zl-tools-dev.nxithub.com → 배지 표시
 *
 * fail-safe: '라이브 호스트가 아니면 무조건 표시'로 둔다. 이렇게 하면 dev 도메인·로컬(localhost/LAN)
 *   등 라이브가 아닌 모든 접속에서 배지가 뜨고, 오직 라이브에서만 숨는다. → 개발서버에서 배지가
 *   누락돼 운영자가 라이브로 오인하는 사고를 구조적으로 차단한다(모호하면 경고를 띄우는 쪽).
 *
 * 참고: bridge-app(키오스크)은 KioskActivity.updateEnvBadge() 로 WebView 위에 네이티브 배지를
 *   그린다. 이 컴포넌트는 브라우저(크롬/PC) 직접 접속 시에도 보이도록 tools 웹 자체에 추가한 것.
 */
import './DevEnvBadge.css';

// 라이브 호스트(권위) — 이 호스트일 때만 개발버전 배지를 숨긴다.
const LIVE_HOST = 'zl-tools.nxithub.com';

export default function DevEnvBadge() {
  const isLive = window.location.hostname === LIVE_HOST;
  if (isLive) return null;
  return (
    <div className="dev-env-badge" aria-hidden="true">개발버전</div>
  );
}
